import { RequestIntersectionsWithPrimitiveCollisionShapeMessage, CollisionShapePrimitive, ResponseIntersectionsWithPrimitiveCollisionShapeMessage } from "../../../messages/selection";
import { convertToNumber3, convertToNumber4 } from "flavr-common";
export class IntenSelect {
    constructor(connection, controllerUid, params // distance compensation factor 1/2 <= k <= 1
    ) {
        var _a, _b, _c, _d, _e;
        this.connection = connection;
        this.controllerUid = controllerUid;
        this.modelUIDToSelectable = new Map();
        this.selectables = [];
        this.stickiness = (_a = params.snappiness) !== null && _a !== void 0 ? _a : 0.5;
        this.snappiness = (_b = params.snappiness) !== null && _b !== void 0 ? _b : 0.5;
        this.threshold = (_c = params.threshold) !== null && _c !== void 0 ? _c : 0.01;
        this.coneHeight = (_d = params.coneHeight) !== null && _d !== void 0 ? _d : 100;
        this.beta = (_e = params.coneAngle) !== null && _e !== void 0 ? _e : (2 * Math.PI) / 180; // defaut = 2°
        this.coneRadius = this.coneHeight * Math.tan(this.beta / 2);
        this.k = 4 / 5;
    }
    hide() {
        this.selectables = [];
        this.modelUIDToSelectable.clear();
    }
    show() { }
    addSelectable(uid) {
        const selectable = {
            uid,
            contrib: 0,
            totalScore: 0
        };
        this.modelUIDToSelectable.set(uid, selectable);
        this.selectables.push(selectable);
        return selectable;
    }
    canSelectionBeUpdated() {
        return true;
    }
    updateSelection(controllerPos, controllerOri, scale, callback) {
        this.connection.ask(new RequestIntersectionsWithPrimitiveCollisionShapeMessage(convertToNumber3(controllerPos), convertToNumber4(controllerOri), scale, CollisionShapePrimitive.CONE, this.coneHeight, this.coneRadius), (answer) => {
            if ((answer.length === 0) || !ResponseIntersectionsWithPrimitiveCollisionShapeMessage.is(answer[0])) {
                throw new Error(`IntenSelect expected a single ${ResponseIntersectionsWithPrimitiveCollisionShapeMessage.typestatic} as answer to ${RequestIntersectionsWithPrimitiveCollisionShapeMessage.typestatic}, but got ${JSON.stringify(answer)}`);
            }
            this.selectables.forEach((it) => (it.contrib = 0));
            const response = answer[0];
            response.selectables.forEach((it) => {
                let selectable = this.modelUIDToSelectable.get(it.uid);
                if (selectable === undefined) {
                    selectable = this.addSelectable(it.uid);
                }
                const x = it.relativePosition[0];
                const y = it.relativePosition[1];
                const z = it.relativePosition[2];
                const perp = Math.sqrt(x * x + y * y);
                const proj = Math.abs(z);
                const alpha = perp / Math.pow(proj, this.k);
                selectable.contrib = 1 - Math.atan(alpha) / this.beta;
            });
            let selection;
            let highestScore = this.threshold;
            this.selectables.forEach((it) => {
                it.totalScore *= this.stickiness;
                it.totalScore += this.snappiness * it.contrib;
                if (it.totalScore > highestScore) {
                    highestScore = it.totalScore;
                    selection = {
                        uid: it.uid,
                        hitPoint: [0, 0, 0]
                    };
                }
            });
            callback(selection);
        });
    }
}
